/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Compare_Section_ImportInputs */



/**
* | output |
* | --- |
* | "File Import" |
*
* @param {Signup_Compare_Section_ImportInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_compare_section_import = /** @type {((inputs?: Signup_Compare_Section_ImportInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Compare_Section_ImportInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("File Import")
	if (locale === "de") return /** @type {LocalizedString} */ ("File Import")
	if (locale === "it") return /** @type {LocalizedString} */ ("File Import")
	if (locale === "ru") return /** @type {LocalizedString} */ ("File Import")
	if (locale === "es") return /** @type {LocalizedString} */ ("File Import")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("File Import")
	if (locale === "ja") return /** @type {LocalizedString} */ ("File Import")
	if (locale === "hi") return /** @type {LocalizedString} */ ("File Import")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("File Import")
	return /** @type {LocalizedString} */ ("File Import")
});